/**
 * @file        src/components/BeyondWordmark.jsx
 * @description Compact Beyond Destination wordmark — the horizontal lockup only
 *              (no travel doodles): teal cursive "Beyond", the airplane
 *              flight-path swash into a jet, and bold "Destination" beneath. Used
 *              where a slim, legible mark is needed (top nav, vouchers). For the
 *              full logo with doodles see <BeyondLogo>.
 *
 *              "Beyond" is always brand teal (--nh-sky); the flight path and
 *              "Destination" use currentColor (white on dark, ink on light — set
 *              via a text-* class). Size it with an h-* and w-auto className; the
 *              SVG scales to fit its viewBox.
 * @author      Kinetika Labs
 * @created     2026-07-21
 * @changelog
 *   - 2026-07-22 Claude — Size now driven by className (viewBox), added the
 *                          flight-path swash + jet, split the doodle version out
 *                          into BeyondLogo.
 *   - 2026-07-21 Claude — Initial. Beyond Destination fork of NeonWordmark.
 */
import React from 'react';

export default function BeyondWordmark({ className = 'h-12 w-auto', showTagline = false }) {
  const teal = 'rgb(var(--nh-sky))';
  return (
    <svg
      className={className}
      viewBox="0 0 300 150"
      fill="none"
      role="img"
      aria-label="Beyond Destination"
      style={{ overflow: 'visible' }}
    >
      <text x="4" y="74" fill={teal} fontFamily="'Yellowtail', cursive" fontSize="70" transform="rotate(-3 4 74)">
        Beyond
      </text>
      <path
        d="M26 84 C 8 80 6 60 24 62 C 34 63 33 74 44 74 L 236 40"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <g transform="translate(224 28) scale(1.15) rotate(48 12 12)">
        <path d="M21 16v-2l-8-5V3.5C13 2.67 12.33 2 11.5 2S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5z" fill="currentColor" />
      </g>
      <text x="86" y="122" fill="currentColor" fontFamily="'Anton', sans-serif" fontSize="34" letterSpacing="2">
        Destination
      </text>
      {showTagline && (
        <text x="88" y="144" fill="currentColor" fontFamily="'Manrope', sans-serif" fontSize="12" fontWeight="800" letterSpacing="3" opacity="0.7">
          FLIGHT | HOTEL | HOLIDAYS | VISA
        </text>
      )}
    </svg>
  );
}
